import { useUpdate } from '../../../../../../../api/react-query';

export function useEditNoticePeriodAutomationStatus(params = {}) {

  const { mutateAsync, isLoading: isEditing } = useUpdate({
    url: 'config/company/noticePeriod-auto/status',
  });

  return {
    editNoticePeriodAutomationStatus: mutateAsync,
    isEditing,
  };
}